import { useAppContext } from '../../../contexts/AppContext'
import CallButton from '../../../components/ui/CallButton'
import { InputProps } from '../types'
import { ViewMode } from '@playbooks/action-cards-utils/src'
import { cn } from '@playbooks/ui/lib/utils'
import InputGroupWrapper from '../../../components/ui/InputGroupeWrapper'
import { InputGroupInput } from '@playbooks/ui/components/input-group'

export default function PhoneInput({
  onChange,
  errorMessage = 'Error',
  question,
  invalid,
}: Omit<InputProps<string>, 'value'>) {
  const {
    settings: { viewMode },
  } = useAppContext()

  const isDocView = viewMode === ViewMode.DOC

  return (
    <InputGroupWrapper className="flex items-center">
      <InputGroupInput
        id={`question-${question.id}`}
        value={(question.value as string) ?? ''}
        onChange={e => onChange(e.target.value)}
        aria-invalid={invalid}
        required={question.required}
        // Safari input padding adjustment. The native safari icon overlaps the phone icon
        style={{ paddingRight: question.value ? '28px' : undefined }}
      />

      <div className="AC_errorMessage text-[red] text-[12px] hidden absolute -bottom-5">{errorMessage}</div>

      {!!question.value && (
        <CallButton
          phone={question.value}
          className={cn(
            'absolute right-1.75 pointer-events-auto',
            isDocView ? 'text-black dark:text-white' : 'text-[#7D7D7D]',
          )}
        />
      )}
    </InputGroupWrapper>
  )
}
